<template>
  <div>
    <v-row class="text-center mt-4 mb-6 mx-6 work-period elevation-2 ">
      <v-col
        cols="12"
        class="noticon-title word-type-txt"
      >
        근무기간
      </v-col>
      <v-col cols="12" class="noticon-text word-type-txt">
        {{ workDate }}
      </v-col>
    </v-row>
    <v-row class="title-wrap">
      <v-col class="d-flex px-6 py-0" cols="12" sm="6">
        <v-select
            :items="items"
            outlined
            v-model="timeCd"
            item-text="timeNm"
            item-value="timeCd"
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="sub-double-btn px-6">
      <v-col cols="6" class="pr-1 py-0 pl-0">
        <v-btn
          block
          elevation="0"
          class="btn-fixed btn-light-grey"
          @click="allAccept"
        >
          <span class="black--text">일괄적용</span>
        </v-btn>
      </v-col>
      <v-col cols="6" class="pl-1 py-0 pr-0">
        <v-btn
          block
          elevation="0"
          class="btn-fixed btn-light-grey"
          @click="init"
        >
          <span class="black--text">재조회</span>
        </v-btn>
      </v-col>
    </v-row>

    <!--list영역 -->
    <div class="overflow-y-auto mx-6 mt-10">
      <v-list class="mb-3" v-for="(item, i) in list" :key="i">
        <v-list-item-group class="app-menu">
          <v-list-item class="px-5" @click="goDay(item)">
            <icon-application :width="24" :height="24" />
            <v-list-item-content>
              <v-list-item-title class="menu-title ml-2"
                >{{ item.minYmd }} ~ {{ item.maxYmd }}</v-list-item-title
              >
            </v-list-item-content>

            <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import IconApplication from '@/assets/customIcon/IconApplication.vue';
import { mapGetters } from 'vuex';
import {
  getTimeInfo,
  getWorkScheduleTimeDate,
  getWorkScheduleTimeDay,
} from '@/api/workStatus';
import routerNames from '@/const/routerConstants';
import dayjs from 'dayjs';

export default {
  data: () => ({
    items: [],
    workDate: '',
    timeCd: '10000',
    timeNm: '',
    list: [],
  }),
  components: { IconApplication },
  computed: {
    ...mapGetters(['GET_DATE', 'GET_WORK_SCHEDULE_TIME_DATA', 'GET_FILE_SEQ']),
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },
  methods: {
    goDay(item) {

      this.$router.push({
        name: routerNames.WorkScheduleTime4,
        params: { item },
      });
    },

    async allAccept() {
      if (
        !confirm(
          '일괄적용시 기존에 설정값이 초기화 되며\n설정한 값으로 일괄적용 됩니다\n계속하시겠습니까?',
        )
      ) {
        return;
      }

      let params = {
        searchSYmd: this.workDate
          .split('~')[0]
          .replaceAll('-', '')
          .replaceAll(' ', ''),
        searchEYmd: this.workDate
          .split('~')[1]
          .replaceAll('-', '')
          .replaceAll(' ', ''),
      };

      let response = await getWorkScheduleTimeDay(params);
      // console.log('getWorkScheduleTimeDay : '+JSON.stringify(response));
      this.saveListOrg = response.data.data;
      this.saveListUpd = this.saveListOrg;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].timeCd === this.timeCd) {
          this.timeNm = this.items[i].timeNm;
        }
      }

      let result = this.saveListUpd.map(obj =>
        obj.ymd >= dayjs().format('YYYYMMDD') &&
        obj.weekNm !== '토요일' &&
        obj.weekNm !== '일요일' &&
        obj.holidayYn === 'N'
          ? {
              ...obj,
              bfTimeCd: obj.timeCd,
              afTimeCd: this.timeCd,
              timeNm: this.timeNm,
              timeCd: this.timeCd,
            }
          : obj,
      );

      this.saveListUpd = result;

      //this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_ORG', this.saveListOrg);
      this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_UPD', this.saveListUpd);

      // console.log('this.saveListUpd : '+JSON.stringify(this.saveListUpd));
    },

    async init() {
      if (!confirm('재조회 처리시 설정값이 초기화 됩니다\n계속하시겠습니까?')) {
        return;
      }

      let params = {
        searchSYmd: this.workDate
          .split('~')[0]
          .replaceAll('-', '')
          .replaceAll(' ', ''),
        searchEYmd: this.workDate
          .split('~')[1]
          .replaceAll('-', '')
          .replaceAll(' ', ''),
      };

      let response = await getWorkScheduleTimeDay(params);
      console.dir(response);
      this.saveListOrg = response.data.data;
      this.saveListUpd = this.saveListOrg;

      //this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_ORG', this.saveListOrg);
      this.$store.commit('SET_WORK_SCHEDULE_TIME_SAVE_UPD', this.saveListUpd);
    },
  },

  async mounted() {

    this.workDate = this.GET_DATE;

    let params = {
      ymd: this.GET_S_YMD.replaceAll('-', ''),
    };

    let response = await getTimeInfo(params);
    this.items = response.data.data;

    // console.log('items : '+JSON.stringify(this.items))

    params = {
      searchSYmd: this.workDate
        .split('~')[0]
        .replaceAll('-', '')
        .replaceAll(' ', ''),
      searchEYmd: this.workDate
        .split('~')[1]
        .replaceAll('-', '')
        .replaceAll(' ', ''),
      workGrpCd: this.GET_WORK_SCHEDULE_TIME_DATA.workGrpCd,
    };

    response = await getWorkScheduleTimeDate(params);
    this.list = response.data.data;

  },
};
</script>
